export { }

declare global {
    interface Date {
        customAddDays(days: number): Date
        customSetHours(hours: number): Date
        customSetDay(day: number): Date
        customAddMonths(months: number): Date
        min(dateToComapare?: Date, ignoreTime?: boolean): Date
        max(dateToComapare?: Date, ignoreTime?: boolean): Date
        sortByDayAndMonth(date: Date, dir: 'asc' | 'desc'): number // spoji mesic a den jako string a udela z nej number (slouzi k razeni podle vyroci, kde se ignoruje rok)
    }
}

Date.prototype.customAddDays = function (days) {
    return customAddDays(new Date(this.valueOf()), days)
}

export const customAddDays = (date: Date, days: number) => {
    var date = new Date(date)
    date.setDate(date.getDate() + days)
    return date
}

Date.prototype.customSetDay = function (day) {
    var date = new Date(this.valueOf())
    return new Date(date.setDate(day))
}

Date.prototype.customSetHours = function (hours) {
    var date = new Date(this.valueOf())
    return new Date(date.setHours(hours))
}

Date.prototype.customAddMonths = function (months) {
    var date = new Date(this.valueOf())
    date.setMonth(date.getMonth() + months)
    return date
}

Date.prototype.sortByDayAndMonth = function (date: Date, dir: 'asc' | 'desc') {
    return sortByDayAndMonth(new Date(this.valueOf()), date, dir)
}

Date.prototype.min = function (date?: Date, ignoreTime?: boolean) {
    return min(new Date(this.valueOf()), date, ignoreTime)
}

Date.prototype.max = function (date: Date, ignoreTime?: boolean) {
    return min(new Date(this.valueOf()), date, ignoreTime)
}

export const sortByDayAndMonth = (date1: Date, date2: Date, dir: 'asc' | 'desc') => {
    var firstDate = new Date(date1);
    firstDate.setFullYear(2000);

    var secondDate = new Date(date2);
    secondDate.setFullYear(2000);

    return dir == "asc"
        ? firstDate.getTime() - secondDate.getTime()
        : secondDate.getTime() - firstDate.getTime();
}

export const min = (date1: Date, date2?: Date, ignoreTime?: boolean) => {
    if (!date2)
        return date1

    const nDate1 = normalizeDate(date1, ignoreTime ?? false)
    const ndate2 = normalizeDate(date2, ignoreTime ?? false)

    return nDate1 <= ndate2 ? date1 : date2
}

export const max = (date1: Date, date2?: Date, ignoreTime?: boolean) => {
    if (!date2)
        return date1

    const nDate1 = normalizeDate(date1, ignoreTime ?? false)
    const ndate2 = normalizeDate(date2, ignoreTime ?? false)

    return nDate1 >= ndate2 ? date1 : date2
}

const normalizeDate = (date: Date, ignoreTime: boolean) => {
    return ignoreTime
        ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
        : new Date(date)
}